import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import store from '@/store'
import iView from 'iview'
import { setToken, getToken, canTurnTo } from '@/libs/util'
import config from '@/config'
const { homeName } = config
Vue.use(Router)
const router = new Router({
  routes,
  // mode: 'history'
})
const LOGIN_PAGE_NAME = 'login'
const turnTo = (to, access, next) => {
  if (canTurnTo(to.name, access, routes)) next() // 有权限，可访问
  else next({ replace: true, name: 'error_401' }) // 无权限，重定向到401页面
}

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  const token = localStorage.getItem('token');
  if (!token && to.name !== LOGIN_PAGE_NAME) {
    // 未登录且要跳转的页面不是登录页
    next({
      name: LOGIN_PAGE_NAME // 跳转到登录页
    })
  } else if (!token && to.name == LOGIN_PAGE_NAME) {
    // 未登陆且要跳转的页面是登录页
    next() // 跳转
  } else if (token && to.name == LOGIN_PAGE_NAME) {
    // 已登录且要跳转的页面是登录页
    next({
      name: homeName // 跳转到homeName页
    })
  } else {
    if (store.state.user.hasGetInfo) {
      turnTo(to, token, next)
    } else {
      if (token) {
        turnTo(to, token, next)
      } else {
        localStorage.setItem('token','')
        localStorage.setItem('user_type','')
        next({
          name: 'login'
        })
      }
    }
  }
})

router.afterEach((from, to) => {
  iView.LoadingBar.finish();
  if (document.getElementById('contentTop')) {
    document.getElementById('contentTop').scrollTop = 0;
  }
  try {
    document.title = Vue.prototype.$selfGlobal.$globalI18n.tc(from.meta.nameText); 
  } catch(e) {
    console.log(e);
    document.title = 'admin'; 
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js